// extracted by mini-css-extract-plugin
module.exports = {"root":"_1D80E","ratioHolder":"jVtmt","contentWrapper":"_3zQCT"};